export default "__VITE_ASSET__CHiAzEZe__"